import React from "react";
import BigCalendar from "react-big-calendar";
import moment from "moment";
import "moment/locale/es";
import { Container, Row, Card, CardBody } from "shards-react";
import api from "../common/api";
import axios from "axios";
import PageTitle from "../common/PageTitle";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";
import LabelIcon from "@material-ui/icons/Label";
import LinearProgress from "@material-ui/core/LinearProgress";
import IconButton from "@material-ui/core/IconButton";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Tooltip from "@material-ui/core/Tooltip";

function EventAgenda({ event }) {
  var id = event.title.split("-")[0].replace("#", "");
  if (id !== "") {
    id = id.replace("❗", "");
  }
  return (
    <p>
      <a
        class="text-decoration-none"
        style={{ color: event.font_color }}
        href={"/work-order/" + id}
      >
        {event.title}
      </a>
    </p>
  );
}

class WorkOrderCalendar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      events: null,
      loaded: false,
      work_order_types: [],
      events_filtered: [{ driver: { id: 0 } }],
      events: [{ driver: { id: 0 } }]
    };
  }

  async componentWillMount() {
    let events = await this.getWorkOrderShifts();
    let alerts = await this.getWorkOrderUserAlerts();
    //events.push(alerts);
    if (alerts !== undefined) {
      events = events.concat(alerts);
    }
    var work_order_types = await this.getWorkOrderTypes();
    work_order_types.unshift({ id: 0, name: "Todas" });
    this.setState({
      ...this.state,
      events,
      loaded: true,
      work_order_types: work_order_types,
      events_filtered: events
    });
  }

  eventStyleGetter = (event, start, end, isSelected) => {
    var style = {
      backgroundColor: event.card_color ? event.card_color : "#007bff",
      borderRadius: "0px",
      opacity: 0.8,
      color: event.font_color ? event.font_color : "#007bff",
      border: "0px",
      display: "block"
    };
    return {
      style: style
    };
  };

  getWorkOrderTypes = () => {
    const token = localStorage.getItem("userToken");
    return axios
      .get(api.dropdowns().ot(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        return res.data.work_order_types;
      })
      .catch(err => {
        console.log(err);
      });
  };

  getWorkOrderShifts = work_order_type_id => {
    const token = localStorage.getItem("userToken");
    var events = [];
    var i = 0;
    return axios
      .get(api.work_order().shifts(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var data = res.data;
        data.map((val, idx) => {
          var event = {};
          event.contract = val.contract;
          event.username = val.user ? val.user.name : "";
          event.driver = val.driver
            ? val.driver.firstname + " " + val.driver.lastname
            : "";
          if (val.schedule.shift_date !== "") {
            event.title = val.budget_approved ? "❗" : "";
            val.schedule.shift_date.replace(" ", "T");
            event.start = new Date(Date.parse(val.schedule.shift_date));
            event.end = new Date(Date.parse(val.schedule.shift_date));
            /*					event.end = new Date(event.end)
					event.end = event.end.setHours(event.end.getHours() + 3);
					event.end = new Date(event.end)*/
            event.card_color = val.type.card_color;
            event.work_order_type_id = val.type.id;
            event.provider = val.schedule.provider.business_name;
            event.id = i;
            event.title =
              event.title +
              "#" +
              val.id +
              " - " +
              val.vehicle.plate +
              "-" +
              val.type.name +
              "-" +
              event.username +
              "-" +
              event.contract +
              "-" +
              event.provider +
              "-" +
              val.state;
            i++;
            event.card_color = val.type.card_color;
            event.font_color = val.type.font_color;
            events.push(event);
          }
          if (val.schedule.start_date !== "" && val.schedule.end_date !== "") {
            event.provider = val.schedule.provider.business_name;
            event.title = val.budget_approved ? "❗" : "";
            //event.title = event.title + '#'+val.id + ' - ' + val.vehicle.plate + '-' + val.type.name
            event.title =
              event.title +
              "#" +
              val.id +
              " - " +
              val.vehicle.plate +
              "-" +
              val.type.name +
              "-" +
              event.username +
              "-" +
              event.contract +
              "-" +
              event.provider +
              "-" +
              val.state;
            event.card_color = val.type.card_color;
            event.font_color = val.type.font_color;
            event.work_order_type_id = val.type.id;
            event.id = i;
            val.schedule.start_date.replace(" ", "T");
            val.schedule.end_date.replace(" ", "T");
            event.start = new Date(Date.parse(val.schedule.start_date));
            event.end = new Date(Date.parse(val.schedule.end_date));
            i++;
            events.push(event);
          }
        });
        return events;
      })
      .catch(err => {
        console.log(err);
      });
  };

  getWorkOrderUserAlerts = () => {
    const token = localStorage.getItem("userToken");
    var events = [];
    var i = 0;
    return axios
      .get(api.work_order_alerts().user_alerts(), {
        headers: { Authorization: `Bearer ${token}` }
      })
      .then(res => {
        var data = res.data;
        data.map((val, idx) => {
          var event = {};
          event.title = "#" + val.work_order_id + " - ❗" + val.subject;
          val.alert_date.replace(" ", "T");
          event.start = new Date(Date.parse(val.alert_date));
          event.end = new Date(Date.parse(val.alert_date));
          event.card_color = val.work_order.type.card_color;
          event.font_color = val.work_order.type.font_color;
          event.work_order_type_id = val.work_order.type.id;
          event.provider = "Alertas";
          event.contract = "Alertas";
          event.driver = "Alertas";
          event.username = val.user.name;
          event.id = i;
          i++;
          events.push(event);
        });
        return events;
      })
      .catch(err => {
        console.log(err);
      });
  };

  handleClickWorkOrder(e, id) {
    if (id !== "") {
      id = id.replace("❗", "");
      window.open("/work-order/" + id, "_blank");
      //	  	window.location.href="/work-order/"+id
    }
  }

  handleChange = e => {
    var events_filtered = this.state.events;
    if (e.target.value !== 0 && e.target.value !== "Todos") {
      events_filtered = this.state.events.filter(
        event => event[e.target.name] === e.target.value
      );
    }
    this.setState({ events_filtered });
  };

  handleDownload = e => {
    this.setState({ backdrop: true });
    const token = localStorage.getItem("userToken");
    var formData = new FormData();
    formData.set("grouped", 0);
    formData.set("vouchers", 0);
    formData.set("closed", 0);
    formData.set("shifts", 1);
    axios
      .post(api.work_order().export(), formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
        window.location.href = response.data;
      })
      .catch(error => {
        alert("Falló la descarga");
      });
  };

  render() {
    const { events_filtered, events } = this.state;
    var contracts = [...new Set(events.map(item => item.contract))];
    var providers = [...new Set(events.map(item => item.provider))];
    var drivers = [...new Set(events.map(item => item.driver))];
    var users = [...new Set(events.map(item => item.username))];
    providers.sort().unshift("Todos");
    contracts.sort().unshift("Todos");
    drivers.sort().unshift("Todos");
    users.sort().unshift("Todos");
    //	const allViews = Object.keys(BigCalendar.Views).map(k => BigCalendar.Views[k]);
    moment.locale("es");
    const localizer = BigCalendar.momentLocalizer(moment);
    const views = ["month", "work_week", "day", "agenda"];
    const messages = {
      date: "Fecha",
      time: "Hora",
      event: "Evento",
      allDay: "Todo el día",
      week: "Semana",
      work_week: "Semana",
      day: "Dia",
      month: "Mes",
      previous: "Atrás",
      next: "Adelante",
      yesterday: "Ayer",
      tomorrow: "Mañana",
      today: "Hoy",
      agenda: "Agenda",
      noEventsInRange: "No hay eventos.",
      showMore: function showMore(total) {
        return "+" + total + " más";
      }
    };
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle title="Turnos" className="text-sm-left mb-3" />
        </Row>
        {this.state.loaded ? (
          <Card className="p-0">
            <CardBody className="py-4">
              <TextField
                id="work_order_type_id"
                placeholder="Ingrese el tipo de siniestro"
                name="work_order_type_id"
                onChange={this.handleChange}
                value={this.state.work_order_type_id}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 60 }}>
                        Tipo de OT
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {this.state.work_order_types.map(option => (
                  <MenuItem
                    key={option.id}
                    value={option.id}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option.name}{" "}
                    <LabelIcon
                      className="ml-1"
                      style={{ color: option.card_color }}
                    />
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="contract"
                placeholder="Ingrese el cliente"
                name="contract"
                onChange={this.handleChange}
                value={this.state.contract}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 60 }}>
                        Cliente
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {contracts.map(option => (
                  <MenuItem
                    key={option}
                    value={option}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="provider"
                placeholder="Ingrese el proveedor"
                name="provider"
                onChange={this.handleChange}
                value={this.state.provider}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 60 }}>
                        Proveedor
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {providers.map(option => (
                  <MenuItem
                    key={option}
                    value={option}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="driver"
                placeholder="Ingrese el conductor"
                name="driver"
                onChange={this.handleChange}
                value={this.state.driver}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 60 }}>
                        Conductor
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {drivers.map(option => (
                  <MenuItem
                    key={option}
                    value={option}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                id="username"
                placeholder="Ingrese el usuario"
                name="username"
                onChange={this.handleChange}
                value={this.state.username}
                select
                margin="normal"
                className="mr-2 mt-0"
                InputLabelProps={{
                  shrink: true
                }}
                inputProps={{ style: { minWidth: 100, fontSize: "0.75rem" } }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Typography variant="caption" style={{ width: 60 }}>
                        Usuario
                      </Typography>
                    </InputAdornment>
                  ),
                  style: { fontSize: "0.75rem" }
                }}
              >
                {users.map(option => (
                  <MenuItem
                    key={option}
                    value={option}
                    style={{ fontSize: "0.75rem" }}
                  >
                    {option}
                  </MenuItem>
                ))}
              </TextField>
              <Tooltip title="Exportar">
                <IconButton
                  className="p-0"
                  onClick={e => {
                    this.handleDownload(e);
                  }}
                >
                  <CloudDownloadIcon />
                </IconButton>
              </Tooltip>
              <BigCalendar
                events={events_filtered}
                messages={messages}
                views={views}
                defaultView={"work_week"}
                step={30}
                popup={true}
                popupOffset={{ x: 30, y: 20 }}
                length={30}
                startAccessor="start"
                endAccessor="end"
                showMultiDayTimes
                defaultDate={new Date()}
                //						elementProps={{ onClick: e => this.handleClickWorkOrder(e,e.target.title.split('-')[0].replace('#','')) }}
                onSelectEvent={e =>
                  this.handleClickWorkOrder(
                    e,
                    e.title.split("-")[0].replace("#", "")
                  )
                }
                eventPropGetter={this.eventStyleGetter}
                localizer={localizer}
                components={{
                  agenda: {
                    event: EventAgenda
                  }
                }}
              />
            </CardBody>
          </Card>
        ) : (
          <LinearProgress />
        )}
      </Container>
    );
  }
}

export default WorkOrderCalendar;
